module.exports = __webpack_public_path__ + "img/bannerimg2.8900b902.png";